import gql from 'graphql-tag';

export const createMultipleMeterReadingValueMutation = gql(/* GraphQL */ `
  mutation createMultipleMeterReadingValueMutation(
    $createMultipleMeterReadingValue: [MeterReadingValueInput!]
    $channelId: String!
  ) {
    createMultipleMeterReadingValue(
      meterReadingValues: $createMultipleMeterReadingValue
      channelId: $channelId
    )
  }
`);
